export const PKG_NAME = "@hpcc-js/dgrid";
export const PKG_VERSION = "3.9.8";
export const BUILD_VERSION = "3.32.0";
